exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".appointments-header {\n  display: flex; }\n  .appointments-header h2 {\n    margin-bottom: 20px;\n    justify-self: start; }\n\n#back-btn {\n  border: none;\n  background: transparent;\n  margin-right: 10px; }\n\n#request-appt {\n  position: relative;\n  float: right;\n  margin-left: auto;\n  margin-top: 15px;\n  margin-bottom: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/scheduler/scheduleHeader/scheduleHeader.scss
// module id = 1419
// module chunks = 0